import type { ViolationGroupInfo, ViolationMessageInfo } from "./types";

type SelectVisibleViolationMessagesParams = {
  readonly typedMessages?: readonly ViolationMessageInfo[] | null;
  readonly fallbackMessages?: readonly string[] | null;
  readonly showManpowerViolations: boolean;
  readonly showConfigViolations: boolean;
  readonly isReadonlyBoard?: boolean;
};

export function isManpowerViolationType(type: string): boolean {
  return type === "manpower_shortage" || type === "manpower_excess";
}

function isManpowerViolationMessage(message: string): boolean {
  return message.includes("인원 미달") || message.includes("인원 초과");
}

export function selectVisibleViolationMessages({
  typedMessages,
  fallbackMessages,
  showManpowerViolations,
  showConfigViolations,
  isReadonlyBoard = false,
}: SelectVisibleViolationMessagesParams): string[] {
  if (isReadonlyBoard) return [];

  if (typedMessages && typedMessages.length > 0) {
    return typedMessages
      .filter((entry) =>
        isManpowerViolationType(entry.type)
          ? showManpowerViolations
          : showConfigViolations
      )
      .map((entry) => entry.message);
  }

  return (fallbackMessages ?? []).filter((message) =>
    isManpowerViolationMessage(message)
      ? showManpowerViolations
      : showConfigViolations
  );
}

export function selectVisibleViolationGroups(
  groups: readonly ViolationGroupInfo[] | null | undefined,
  {
    showManpowerViolations,
    showConfigViolations,
  }: {
    readonly showManpowerViolations: boolean;
    readonly showConfigViolations: boolean;
  }
): ViolationGroupInfo[] {
  return (groups ?? []).filter((group) =>
    isManpowerViolationType(group.type)
      ? showManpowerViolations
      : showConfigViolations
  );
}
